import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-446a9148"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-page__content-container" }
const _hoisted_2 = { class: "home-page__header" }
const _hoisted_3 = {
  key: 0,
  class: "home-page__news-badge"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "home-page__content" }
const _hoisted_6 = { class: "home-page__intro" }
const _hoisted_7 = { class: "home-page__button-wrapper" }

import { computed } from 'vue';
import { IonPage, IonContent, IonText } from '@ionic/vue';
import { RoutePath } from '@/enums/Router';
import logo from '@/assets/images/logo.svg';
import BaseButton from '@/components/BaseButton.vue';
import ComputeStepSlider from '@/components/ComputeStepSlider.vue';
import { useI18n } from 'vue-i18n';
import { Icons } from '@/enums/Icons';
import BaseIcon from '@/components/BaseIcon.vue';
import { useComputeWizardStore } from '@/store/computeWizard';
import StepButtonGrid from '@/components/StepButtonGrid.vue';
import CalculationResult from '@/components/CalculationResult.vue';
import useNewsSettings from '@/composables/useNewsSettings';
import useModal from '@/composables/useModal';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const newsSettings = useNewsSettings();
const computeWizardStore = useComputeWizardStore();
const { displayAsModal } = useModal();

const { t } = useI18n();

const buttonLabel = computed(() => {
  return computeWizardStore.isValid ? t('home.new') : t('home.start');
});

const resetFinalCalculus = () => {
  computeWizardStore.resetValues();
  displayCalculusStep();
};

const displayCalculusStep = async (stepIndex = 0) => {
  displayAsModal(ComputeStepSlider, { requestedStep: stepIndex }).then(() => {
    computeWizardStore.updateFinalResult();
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), { class: "home-page" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), {
        class: "home-page__container",
        forceOverscroll: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("header", _hoisted_2, [
              _createVNode(BaseButton, {
                class: "home-page__header-button",
                fill: "clear",
                "router-link": _unref(RoutePath).NEWS,
                onClick: _unref(newsSettings).checkLastVisit
              }, {
                default: _withCtx(() => [
                  _createVNode(BaseIcon, {
                    icon: _unref(Icons).Light
                  }, null, 8, ["icon"]),
                  (_unref(newsSettings).hasNews())
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["router-link", "onClick"]),
              _createElementVNode("img", {
                src: _unref(logo),
                alt: "",
                class: "home-page__header-logo",
                width: "48",
                height: "55"
              }, null, 8, _hoisted_4),
              _createVNode(BaseButton, {
                class: "home-page__header-button",
                fill: "clear",
                "router-link": _unref(RoutePath).SETTINGS
              }, {
                default: _withCtx(() => [
                  _createVNode(BaseIcon, {
                    icon: _unref(Icons).Gear
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["router-link"])
            ]),
            _createElementVNode("main", _hoisted_5, [
              (_unref(computeWizardStore).isValid)
                ? (_openBlock(), _createBlock(CalculationResult, { key: 0 }))
                : (_openBlock(), _createBlock(_unref(IonText), {
                    key: 1,
                    color: "light"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('home.intro')), 1)
                    ]),
                    _: 1
                  })),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(BaseButton, {
                  class: "home-page__button",
                  rounded: "",
                  expand: "block",
                  color: "light",
                  onClick: resetFinalCalculus,
                  icon: _unref(Icons).NextArrow
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(buttonLabel.value), 1)
                  ]),
                  _: 1
                }, 8, ["icon"])
              ]),
              _createVNode(StepButtonGrid, {
                class: "home-page__step-grid",
                onRequestDisplayStep: displayCalculusStep
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})